/**
 * DialogListItem
 */
import React from 'react';
import { Icon, Link as LinkBase } from 'ui-component-library/base';
import { useUuid } from 'ui-component-library/hooks';
/** Naviagation list with links. */
var DialogListItem = function (_a) {
    var updated = _a.updated, heading = _a.heading, numberOfComments = _a.numberOfComments, _b = _a.url, url = _b === void 0 ? '#' : _b, _c = _a.headingLevel, headingLevel = _c === void 0 ? 'h2' : _c, _d = _a.LinkComponent, LinkComponent = _d === void 0 ? LinkBase : _d;
    var getUuid = useUuid()[0];
    var dialogId = getUuid();
    var Heading = headingLevel;
    var Link = LinkComponent;
    return (React.createElement("article", { "data-cid": "DialogListItem" },
        React.createElement(Link, { to: url, className: "block pb-3 mb-3 no-underline border-b-2 border-greyLight group", "aria-labelledby": "dialog-heading-" + dialogId },
            updated && (React.createElement("p", { className: "text-p text-greyDarker", "aria-hidden": true },
                React.createElement("span", null, updated),
                React.createElement("span", { className: "ml-3" },
                    React.createElement(Icon, { icon: "chatMessage", className: "search-result-icon mr-1" }),
                    numberOfComments))),
            React.createElement("header", { className: "flex justify-between items-baseline" },
                React.createElement(Heading, { className: "text-h3 text-teal group-hover:underline", id: "dialog-heading-" + dialogId }, heading),
                !updated && (React.createElement("span", { className: "flex items-center ml-2 text-p text-greyDark", "aria-hidden": true },
                    React.createElement(Icon, { icon: "chatMessage", className: "search-result-icon mr-1" }),
                    numberOfComments))))));
};
export default DialogListItem;
